import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getUserRoleOptions = get('guest.userRoleOptions');

export const getAll = createSelector(getUserRoleOptions, get('all'));

export const getMeta = createSelector(getUserRoleOptions, get('meta'));

export const getFetching = createSelector(getUserRoleOptions, get('fetching'));

export const getFetched = createSelector(getUserRoleOptions, get('fetched'));
